import { UploadedTimetableContent } from "../../components/app/uploadedTimetable/content";

const UploadedTimetable = () => {
  return <UploadedTimetableContent />;
};

export default UploadedTimetable;
